// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"22":"cdb514d3","628":"488ef3d7"}[chunkId] + ".js";
};